import NumbersMixin from "./NumbersMixin";

export default {
  mixins: [NumbersMixin],
  methods: {
    calculateInstallments(paymentMode, total) {
      const totalArredondado = this.round(parseFloat(total) || 0, 2);
      if (paymentMode?.descricao === 'Nenhum') return [{ value: 0, date: this.$moment().format("YYYY-MM-DD") }]
      if (paymentMode?.tipo_repeticao === 0) return [{ value: totalArredondado, date: this.$moment().format("YYYY-MM-DD") }]
      const range = this.getRange(totalArredondado, paymentMode.vezes);
      return this.setRangeDates(paymentMode, range);
    },
    getRange(total, repeatTimes) {
      const partialValue = this.divide(total, repeatTimes);
      const range = Array.from({ length: repeatTimes }, () => ({
        value: partialValue,
      }));

      const rest = this.subtract(
        total,
        this.multiply(partialValue, repeatTimes)
      );
      range[0].value = this.add(partialValue, rest);
      return range;
    },
    setRangeDates(paymentMode, range) {
      if (!paymentMode?.default && paymentMode?.intervalo_dias) {
        // ✅ Caso especial: lista de offsets (15/30/60) a partir de uma data base
        if (paymentMode.tipo_repeticao === 9 && Array.isArray(paymentMode.intervalo_dias.intervalo)) {
          const baseDate = this.$moment();

          return range.map((portion, index) => {
            const intervaloData = paymentMode.intervalo_dias.intervalo[index];

            // fallback defensivo
            const offset = intervaloData?.periodo_qtd ?? 0;
            const period = intervaloData?.periodo_descricao ?? "days";

            const date = baseDate.clone().add(offset, period).format("YYYY-MM-DD");

            return {
              ...portion,
              date,
            };
          });
        }

        // ✅ Demais tipos: sequencial (mensal, semanal, etc.)
        let previousDate = null;

        return range.map((portion) => {
          const intervaloData = paymentMode.intervalo_dias.intervalo;
          const offset = intervaloData.periodo_qtd;
          const period = intervaloData.periodo_descricao;

          const currentDate = !previousDate
            ? this.$moment().add(offset, period)
            : previousDate.clone().add(offset, period);

          previousDate = currentDate.clone();

          return {
            ...portion,
            date: currentDate.format("YYYY-MM-DD"),
          };
        });
      }

      return range;
    },
    getIncrement(paymentMode) {
      if (!paymentMode.repeatType || !paymentMode.repeatType.modifier) {
        return {
          value: 1,
          period: "month"
        };
      }

      return {
        value: parseInt(paymentMode.repeatType.modifier.periodQty, 10),
        period: paymentMode.repeatType.modifier.periodName
      };
    }
  }
};
